import { useQuery } from '@tanstack/react-query';

import { clientApi } from '@/config/axios';
import { useAuth } from '@/lib/auth/AuthContext';

export interface TemplateSummary {
  id: string;
  name: string;
  category: string;
  is_active: boolean;
  enable_tagging: boolean;
}

export interface PickerTemplatesParams {
  category?: 'document' | 'context_view';
  active_only?: boolean;
}

export function usePickerTemplates(params?: PickerTemplatesParams) {
  const { organization } = useAuth();
  const orgId = organization?.organization_id;

  return useQuery({
    queryKey: ['templates', orgId, params],
    queryFn: async () => {
      const { data } = await clientApi.get<TemplateSummary[]>(
        `/api/v1/organizations/${orgId}/templates`,
        { params },
      );
      return data;
    },
    enabled: !!orgId,
  });
}
